import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, deleteRequest, postRequest } from 'utils/http'

const GALLERY_QUERY_KEY = 'galleries'

// =========================================================
//                   GALLERY QUERIES
// =========================================================

export const getGallery = async () => {
  const response = await getRequest(GALLERY_QUERY_KEY)
  return response.data
}

export const useGetGallery = () => {
  return useQuery({
    queryKey: [GALLERY_QUERY_KEY],
    queryFn: getGallery,
  })
}

export const createGallery = async (newGalleryData) => {
  return postRequest(GALLERY_QUERY_KEY, newGalleryData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const useCreateGallery = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createGallery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GALLERY_QUERY_KEY] })
    },
  })
}

export const updateGallery = async (params) => {
  const { id, updatedData } = params
  updatedData.append('_method', 'PUT')
  return postRequest(`${GALLERY_QUERY_KEY}/${id}`, updatedData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const useUpdateGallery = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateGallery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GALLERY_QUERY_KEY] })
    },
  })
}

export const deleteGallery = async id => {
  return deleteRequest(`${GALLERY_QUERY_KEY}/${id}`)
}

export const useDeleteGallery = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteGallery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GALLERY_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to delete gallery item:', error)
    },
  })
}
